export const language: any = {
    LabelLogin: "登录",
    LabelForgotPw: "找回密码",
    LabelSignUp: "注册",
    LabelRememberMe: "保持登录状态",
    Or: "或者",
    Email: "邮箱",
    Password: "密码",
    LangKo: "韩语",
    LangEn: "英语",
    LangVi: "越南语",
    LabelCondition: "同意条款",
    FullAgreement: "全部同意",
    Next: "下一步",
    PrivacyPolicy: `隐私政策 <span class="text-[#ff6741]">(必填)</span>`,
    TermOfUse: `使用条款 <label class="text-[#ff6741]">(必填)</label>`,
    VerifyPassword: "确认密码",
    PlaceHolderPassword: "请输入包含字母、数字和特殊字符的至少8位密码",
    DuplicateCheck: "重复检查",
    LabelIdEmail: "账号（邮箱）",
    GN_02_MSG_01: "您的应用版本已过时。请升级以继续使用。",
    AU_02_MSG_02: "该邮箱已注册。请使用其他邮箱。",
    AU_02_MSG_03: "邮箱可用。",
    AU_02_MSG_01: "请输入正确的邮箱格式。",
    AU_01_MSG_01: "账号或密码不正确。请重试。",
    AU_02_MSG_04: "请检查可用邮箱。",
    AU_02_MSG_05: "请输入至少8位，包含字母、数字和特殊字符的密码。",
    AU_02_MSG_06: "密码不一致。",
    AU_03_MSG_01: "请正确输入邮箱。",
    AU_03_MSG_02: "该邮箱未注册。",
    AU_03_MSG_04: "※ 验证码已发送到注册邮箱。",
    LabelRegisterComplete: "注册完成！",
    LabelLoginToUseService: "请登录后使用服务。",
    LabelDontRememberPassword: "忘记密码了吗？",
    LabelYouCanFindEmail: "您可以通过邮箱验证找回。",
    LabelPasswordTemporarySendToEmail: "※ 将向您的注册邮箱发送临时密码。",
    SendVerifyNumber: "发送验证码",
    LabelCheckYourEmailForTemporaryPassword: "请在邮箱中检查临时密码。",
    PlaceHolderTemporaryPassword: "输入临时密码",
    LabelTemporaryPassword: "临时密码",
    LabelDidntReceiveYourPassword: "没有收到密码？",
    LabelYouCanResendItAfter: "后可重新发送。",
    LabelYouCanResendAgain: "可以重新发送。",
    Confirm: "确认",
    Resend: "重新发送",
    LabelResetPassword: "重置密码",
    NewPassword: "新密码",
    ConfirmNewPassword: "确认新密码",
    PlaceHolderConfirmPassword: "确认密码",
    CurrentPassword: "当前密码", // menu
    LanguageSetting: "语言设置", // menu
    LeaveMembership: "注销会员", // menu
    LabelConfirmPasswordToLeaveMemberShip: "请输入密码以注销会员。", // menu
    LabelConfirmPasswordMeansYouAgreeAllContent: "输入密码表示您已阅读并同意所有内容。", // menu
    LabelCancelMembership: "注销会员", // menu
    LabelBeforeLeaveYouCheckedContent: "请在注销前阅读并勾选以下内容。", // menu
    LabelAfterLeaveAllInfoWillRemove: "注销后，您的信息和记录将被删除，无法恢复。", // menu
    LabelIHaveReadAndAgreeContent: "我已阅读并同意以上内容。", // menu
    ToUnsubscribe: "注销", // menu
    LabelWouldYouWantLogout: "您确定要退出登录吗？", // menu
    ChangePassword: "修改密码", // menu
    Menu: "菜单", // menu
    MenuLanguageSettings: "语言设置", // menu
    MenuPrivacyPolicy: "隐私政策", // menu
    MenuLogout: "退出登录", // menu
    MenuLeaveMembership: "注销会员", // menu
    LabelAreYouSureLeaveMembership: "您确定要注销会员吗？", // menu
    LabelIfLeaveMembershipAllInfoWillRemove: "注销后您的账号信息将被删除，无法恢复。", // menu
    LabelPrivacyPolicy: "隐私政策",
    LabelTermOfUse: "使用条款",
    MI_02_MSG_01: "当前密码不正确。",
    LabelModalLogin: `要使用此功能请登录或注册。`,
    LabelIdLogin: "使用ID登录",
    LabelSnsApple: "通过Apple登录",
    LabelSnsFacebook: "通过Facebook登录",
    LabelSnsGoogle: "通过Google登录",
    LabelItemLogin: "Hey! 想与Cooker一起探索各种功能，请登录或注册。",
    LabelSnsEmail: "通过电子邮件登录",
    LoadingLogin: "请稍等。",
    MenuNotificationSettings: "通知設置 (繁體)", //menu
};
